module.exports = __webpack_public_path__ + "static/media/foundPair.a75c2497.wav";